<div class="form-group">
  <label [innerHTML]="label"></label>
  <div class="input-group">
    <span class="input-group-prepend">
      <div class="input-group-text bg-transparent"><span [class.fa-search]="searching" [class.fa-filter]="filtering" class="fa"></span></div>
    </span>
    <input [(ngModel)]="searchTerm" [placeholder]="mode" class="prepended appended form-control py-2 border-left-0 border" type="text" value="search">
    <span class="input-group-append text-btn" (click)="ClearSearch()">
      <div class="input-group-text bg-transparent"><span class="fa fa-times"></span></div>
    </span>
  </div>
  <div class="auto-complete" *ngIf="hasResults">
    <div class="select-item"  *ngFor="let item of results" [innerHTML]="GetLabel(item)" (click)="Select(item)"></div>
  </div>

</div>
